import { useEffect, useRef, useState } from "react";
import { api, API } from "@/lib/api";
import { copyText, dmLink } from "@/lib/copy";
import { streamSSE } from "@/lib/sse";

export const SUBJECT = { invite: "you're in: nobo run club", nudge: "missed you at nobo" };

export const InviteDraft = ({ s, run, kind = "invite" }) => {
  const [text, setText] = useState("");
  const [state, setState] = useState("writing");
  const [copied, setCopied] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const saved = useRef("");

  useEffect(() => {
    const ctrl = new AbortController();
    setText("");
    setState("writing");
    let full = "";
    streamSSE(`${API}/admin/signups/${s.id}/${kind}`, run, (t) => { full += t; setText(full); }, { signal: ctrl.signal, credentials: "include" })
      .then(() => { saved.current = full.trim(); setText(full.trim()); setState("done"); })
      .catch((e) => { if (e.name !== "AbortError") setState("error"); });
    return () => ctrl.abort();
  }, [s.id, run, attempt, kind]);

  const save = () => { if (text.trim() && text !== saved.current) { saved.current = text; api.put(`/admin/signups/${s.id}/${kind}`, { text }); } };
  const copy = async () => { await copyText(text); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  const link = dmLink(s.contact, text, SUBJECT[kind]);
  const p = kind;

  return (
    <li className="draft" data-testid={`${p}-draft-${s.id}`}>
      <div className="org-head"><strong>{s.name}</strong><span className="org-contact">{s.contact}</span></div>
      <textarea value={text} readOnly={state !== "done"} onChange={(e) => setText(e.target.value)} onBlur={save}
        placeholder="writing..." rows={6} data-testid={`${p}-text-${s.id}`} />
      {state === "error" && <p className="err" data-testid={`${p}-error-${s.id}`}>The AI couldn't write this one.</p>}
      <div className="draft-actions">
        {state === "error" && <button className="pill dark" onClick={() => setAttempt((a) => a + 1)} data-testid={`${p}-retry-${s.id}`}>try again</button>}
        {state === "done" && <button className="go small" onClick={copy} data-testid={`${p}-copy-${s.id}`}>{copied ? "copied" : "copy message"}</button>}
        {state === "done" && link && <a className="pill dark" href={link} target="_blank" rel="noopener noreferrer" onClick={copy} data-testid={`${p}-open-dm-${s.id}`}>{link.startsWith("mailto") ? "open email" : "copy & open DM"}</a>}
        {state === "writing" && <span className="org-msg" data-testid={`${p}-writing-${s.id}`}>writing...</span>}
      </div>
    </li>
  );
};
